/** @jsx h */
import { h } from 'preact'

import Packaging from './Packaging'
import t from '../../../../utils/translate'

const Unrecyclable = ({ packaging }) => {
  if (!packaging || !packaging.length) {
    return null
  }
  return (
    <section>
      <h3 class='ModalCard-heading'>{t('proof_points.js.recycling.results.unrecyclable.title')}</h3>
      <p class='ModalCard-para u-marginTop8'>You can't currently recycle the <Packaging packagingList={packaging} connector='or' /> in your area.</p>
    </section>
  )
}

export default Unrecyclable
